import React, { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess, manualFormsListActionId, formBillingTypeActionId } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getManualformsMasterList_action, insertUpdateManualFormsMaster_action, deleteManualformsMaster_action } from "../../../../../actions/admin_module_action/master_action/exhibition_master_action/manual_forms_master_action";

const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
        onClick={onClick}
        ref={ref}
        value={value}
        className="form-control"
        style={{ width: "100px" }}   // INLINE WIDTH HERE
    />
));

class ManageArea extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            list: [],
            manualFormsList: [],
            ManualFormMappingID: '',
            isOpen: false,
            toAdd: false,
            formBillingTypeList: [],
            ExhibitionID: this.props.location.state?.ExihibitionID || null
        }
        this.onDeleteRow = this.onDeleteRow.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onAddRow = this.onAddRow.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.getManualFormsMasterList = this.getManualFormsMasterList.bind(this)
        // this.addManualFormsMasterList = this.addManualFormsMasterList.bind(this)
        this.insertUpdateManualFormsMasterList = this.insertUpdateManualFormsMasterList.bind(this)
        this.onPriceINRChange = this.onPriceINRChange.bind(this)
        this.onPriceUSDChange = this.onPriceUSDChange.bind(this)
        this.onDateChange = this.onDateChange.bind(this)
        this.onNameChange = this.onNameChange.bind(this)
    }

    async componentDidMount() {
        const { location, id } = this.props;

        await this.getFillList(manualFormsListActionId, '', '', '', '', '');
        await this.getFillList(formBillingTypeActionId, '', '', '', '', '');
        setTimeout(async () => {

            await this.getManualFormsMasterList();
        }, 200);
    }

    onAddRow(e) {
        const { formBillingTypeList } = this.state
        e.preventDefault();
        // console.log(this.state.listLength)
        const { list } = this.state
        var id = list.length + 1
        var map = {
            Deadline: "",
            // Mandatory: 0,
            ManualFormID: '',
            ManualFormMappingID: null,
            PriceINR: null,
            PriceUSD: null,
            isAdd: true,
            isUpdate: true,
            isDirectApproval: false,
            FormBillingType: 1,
            formBillingTypeList: formBillingTypeList,
            isVendorSelectionAllowed: false,
            isITMEBilling: false,
        }
        console.log("map--------------->", map)
        list.push(map)
        this.setState({ list: list, })
        // console.log(this.state.StallSizeList)
    }

    // Get Fill Lists
    async getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true });

        return this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error !== 1) {

                    if (actionID === manualFormsListActionId) {
                        this.setState({ manualFormsList: data.data });
                    }

                    if (actionID === formBillingTypeActionId) {
                        this.setState({ formBillingTypeList: data.data });
                    }

                } else {
                    toastError(data.msg);
                }

                this.setState({ isLoading: false });
                return data; // <— important
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
                throw e; // <— important to propagate errors
            });
    }


    async getManualFormsMasterList() {
        const { formBillingTypeList, manualFormsList } = this.state
        console.log("formBillingTypeList--->", this.state.formBillingTypeList)
        this.setState({ isLoading: true })
        this.props.getManualformsMasterList_action(this.props.location.state.ExihibitionID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        if (data.data[0].length > 0) {
                            data.data[0].map(element => {
                                element.isUpdate = false
                                element.isAdd = false
                                element.isDirectApproval = element.isDirectApproved
                                element.FormBillingType = formBillingTypeList.find(item => item.ManualformBillingTypeID === element.FormBillingType)?.ManualformBillingTypeID
                                element.formBillingTypeList = formBillingTypeList
                            })
                            console.log(data.data)
                            this.setState({
                                list: data.data[0],
                                isAdd: false
                            })
                        }
                        else {
                            this.setState({ isAdd: true })
                        }
                    }
                    else {
                        this.setState({ isAdd: true })
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateManualFormsMasterList() {
        const { list, ExhibitionID } = this.state
        console.log(list)

        var finalList = []

        for (var i = 0; i < list.length; i++) {
            if (list[i].isUpdate == true) {
                finalList.push(list[i])
            }
        }
        if (list.some(item => !item.ManualFormID || !item.Deadline)) {
            toastError("Please fill all the mandatory fields");
        }

        else {
            for (var i = 0; i < finalList.length; i++) {
                var obj = finalList[i]
                delete obj.isAdd
                delete obj.isUpdate
            }
            this.setState({ isLoading: true })
            console.log(finalList)
            this.props.insertUpdateManualFormsMaster_action(ExhibitionID, finalList)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false })
                        this.getManualFormsMasterList()
                        toastSuccess("update successfully")
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    onDelete(i) {
        const { list } = this.state
        // var ManualFormMappingID = list[i].ManualFormMappingID
        if (list[i].isAdd == true) {
            list.splice(i, 1)
            this.setState({ list: list })
        }
        else {
            // this.setState({ isLoading: true })
            this.setState({ ManualFormMappingID: list[i].ManualFormMappingID })
            this.setState({ isOpen: true })

        }
    }

    onDeleteRow() {
        const { ManualFormMappingID, ExhibitionID } = this.state
        this.props.deleteManualformsMaster_action(ExhibitionID, ManualFormMappingID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isOpen: false })
                    this.setState({ isLoading: false, list: [] })

                    this.setState({ isLoading: false })
                    toastSuccess("delete successfully")
                    this.getManualFormsMasterList()
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onPriceINRChange(e, ID) {
        e.preventDefault()
        const { list } = this.state
        list.map((data, i) => {
            if (ID == i) {
                data.PriceINR = parseFloat(e.target.value)
                data.isUpdate = true
            }
        })
        setTimeout(() => {
            console.log(list)
            this.setState({ list: list })
        }, 200);
    }

    onPriceUSDChange(e, ID) {
        e.preventDefault()
        const { list } = this.state
        list.map((data, i) => {
            if (ID == i) {
                data.PriceUSD = parseFloat(e.target.value)
                data.isUpdate = true
            }
        })
        setTimeout(() => {
            console.log(list)
            this.setState({ list: list })
        }, 200);
    }

    onDateChange(e, ID) {
        // e.preventDefault()
        const { list } = this.state
        console.log(e)
        list.map((data, i) => {
            if (ID == i) {
                data.Deadline = e ? new Date(moment(e, 'DD-MM-YYYY').format('YYYY-MM-DD')) : null
                data.isUpdate = true
            }
        })
        setTimeout(() => {
            console.log(list)
            this.setState({ list: list })
        }, 200);
    }

    onCheckboxChange(e, ID, params) {
        // e.preventDefault()
        const { list } = this.state
        console.log(e)
        list.map((data, i) => {
            if (ID == i) {
                if (params == 'isDirectApproval') {
                    data.isDirectApproval = e.target.checked
                } else if (params == 'isVendorSelectionAllowed') {
                    data.isVendorSelectionAllowed = e.target.checked
                    if (!e.target.checked) {
                        data.IsNonEmpanelCard = false
                        data.SendVendorLogin = false
                    }
                } else if (params == 'isITMEBilling') {
                    data.isITMEBilling = e.target.checked
                    if (e.target.checked) {
                        data.optionForBillRaised = false
                    }
                } else if (params == 'optionForBillRaised') {
                    data.optionForBillRaised = e.target.checked
                } else if (params == 'IsNonEmpanelCard') {
                    data.IsNonEmpanelCard = e.target.checked
                } else if (params == 'SendVendorLogin') {
                    data.SendVendorLogin = e.target.checked
                }else if (params == 'IsMandatory') {
                    data.IsMandatory = e.target.checked
                }
                data.isUpdate = true
            }
        })
        this.setState({ list: list })
    }

    onRadioChange(e, ID, ManualformBillingTypeID) {
        // e.preventDefault()
        const { list, formBillingTypeList } = this.state
        list.map((data, i) => {
            if (ID == i) {
                const selecteId = formBillingTypeList.find(item => item.ManualformBillingTypeID === ManualformBillingTypeID).ManualformBillingTypeID;
                data.FormBillingType = selecteId
                data.isUpdate = true
            }
        })
        setTimeout(() => {
            console.log(list)
            this.setState({ list: list })
        }, 200);
    }

    onNameChange(e, ID) {
        // e.preventDefault()
        const { list } = this.state
        console.log(e.target.value)
        var checkForm = false
        for (var i = 0; i < list.length; i++) {
            if (parseInt(e.target.value) == list[i].ManualFormID) {
                checkForm = true
                break
            }
        }
        if (checkForm == true) {
            toastError("Manual form already select in list")
        }
        else {

            list.map((data, i) => {
                if (ID == i) {
                    data.ManualFormID = parseInt(e.target.value)
                    data.isUpdate = true
                }
            })
        }
        setTimeout(() => {
            console.log(list)
            this.setState({ list: list })
        }, 200);
    }

    render() {
        const { isLoading, isOpen, list, manualFormsList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <AdminDrawer />
                <div className="main-container exb-top-space-2">
                    <div className="row m-0">
                        <div className="table-responsive mt-2" style={{height:'calc(100vh - 200px)'}}>
                            <table className="table border px-1 text-nowrap text-md-nowrap table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-center" >Name<span style={{ color: 'red' }}>*</span></th>
                                        <th className="text-center" >Deadline<span style={{ color: 'red' }}>*</span></th>
                                        {/* <th className="text-center">Price (INR)</th> */}
                                        {/* <th className="text-center">Price (USD)</th> */}
                                        <th className="text-center">Form Billing Type</th>
                                        <th className="text-center">Config</th>
                                        <th style={{ width: '60px' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        list.length > 0 ? <>{
                                            list.map((data, i) => (
                                                <tr>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            value={data.ManualFormID}
                                                            onChange={(e) => this.onNameChange(e, i)}
                                                            style={{ width: '400px' }}
                                                        >
                                                            <option value={""}>Select</option>
                                                            {manualFormsList.length > 0 &&
                                                                manualFormsList.map((data) => (
                                                                    <option key={data.ManualFormID} value={data.ManualFormID}>
                                                                        {data.DisplayName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </td>
                                                    <td >
                                                        <DatePicker
                                                            selected={data.Deadline ? new Date(data.Deadline) : null}
                                                            dateFormat={"dd-MM-yyyy"} className="form-control"
                                                            onChange={(e) => this.onDateChange(e, i)}
                                                            style={{ width: '150px !important' }}
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            placeholderText="dd-mm-yyyy"
                                                            customInput={<CustomInput />}
                                                            dayClassName={() => "example-datepicker-day-class"}
                                                            popperClassName="example-datepicker-class" />

                                                    </td>
                                                    {/* <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder=""
                                                        value={data.PriceINR}
                                                        // disabled={true}
                                                        onChange={(e) => this.onPriceINRChange(e, i)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder=""
                                                        value={data.PriceUSD}
                                                        // disabled={true}
                                                        onChange={(e) => this.onPriceUSDChange(e, i)}
                                                    />
                                                </td> */}
                                                    <td className="text-center">
                                                        <div className="d-flex">
                                                            {data.formBillingTypeList.map((item, index) => (
                                                                <span className="d-flex">
                                                                    <input
                                                                        type="radio"
                                                                        name={`FormBillingType-${i}`}
                                                                        checked={data.FormBillingType === item.ManualformBillingTypeID}
                                                                        // disabled={true}
                                                                        onChange={(e) => this.onRadioChange(e, i, item.ManualformBillingTypeID)}
                                                                    />{item.ManualformBillingType}&emsp;
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="d-flex">
                                                            <span className="d-flex">
                                                                <input
                                                                    type="checkbox"
                                                                    placeholder=""
                                                                    checked={data.IsMandatory}
                                                                    // disabled={true}
                                                                    onChange={(e) => this.onCheckboxChange(e, i, 'IsMandatory')}
                                                                />Mandatory Form
                                                            </span>
                                                            <span className="ml-2 d-flex">
                                                                <input
                                                                    type="checkbox"
                                                                    placeholder=""
                                                                    checked={data.isDirectApproval}
                                                                    // disabled={true}
                                                                    onChange={(e) => this.onCheckboxChange(e, i, 'isDirectApproval')}
                                                                />Direct Approval
                                                            </span>
                                                            <span className="ml-2 d-flex">
                                                                <input
                                                                    type="checkbox"
                                                                    placeholder=""
                                                                    checked={data.SendVendorLogin}
                                                                    // disabled={true}
                                                                    onChange={(e) => this.onCheckboxChange(e, i, 'SendVendorLogin')}
                                                                />Send Service Partner Login
                                                            </span>
                                                            <span className="ml-2 d-flex">
                                                                <input
                                                                    type="checkbox"
                                                                    placeholder=""
                                                                    checked={data.isVendorSelectionAllowed}
                                                                    // disabled={true}
                                                                    onChange={(e) => this.onCheckboxChange(e, i, 'isVendorSelectionAllowed')}
                                                                />Service Partner Selection Allowed
                                                            </span>
                                                            {data.isVendorSelectionAllowed &&
                                                                <>
                                                                    <span className="ml-2 d-flex">
                                                                        <input
                                                                            type="checkbox"
                                                                            placeholder=""
                                                                            checked={data.IsNonEmpanelCard}
                                                                            // disabled={true}
                                                                            onChange={(e) => this.onCheckboxChange(e, i, 'IsNonEmpanelCard')}
                                                                        />Show Non-Empanel Card
                                                                    </span>
                                                                </>
                                                            }
                                                            <span className="ml-2 d-flex">
                                                                <input
                                                                    type="checkbox"
                                                                    placeholder=""
                                                                    checked={data.isITMEBilling}
                                                                    // disabled={true}
                                                                    onChange={(e) => this.onCheckboxChange(e, i, 'isITMEBilling')}
                                                                />ITME Billing
                                                            </span>
                                                            {!data.isITMEBilling &&
                                                                <span className="ml-2 d-flex">
                                                                    <input
                                                                        type="checkbox"
                                                                        placeholder=""
                                                                        checked={data.optionForBillRaised}
                                                                        // disabled={true}
                                                                        onChange={(e) => this.onCheckboxChange(e, i, 'optionForBillRaised')}
                                                                    />Option For Bill Raised
                                                                </span>
                                                            }
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        <i className="fa fa-trash-o grid-icon"
                                                            onClick={() => this.onDelete(i)}
                                                        />
                                                    </td>

                                                </tr>
                                            ))}
                                        </> :
                                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div style={{ textAlign: 'right' }} >

                            <button type="button" class="btn btn-aqua rounded-1 mt-3 " onClick={(e) => this.onAddRow(e)}>
                                Add Row
                            </button>
                            <button disabled={list.length == 0} type="button" class="btn btn-aqua rounded-1 mt-3 ms-2"
                                onClick={(e) => this.insertUpdateManualFormsMasterList(e)}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            {/* <div class="modal-header text-right p-2">
                                <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div> */}
                            <div class="modal-body">
                                <div class="row">
                                    <h5 class="modal-title">Do you really want to delete this record?</h5>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.onDeleteRow()}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getManualformsMasterList_action, insertUpdateManualFormsMaster_action, deleteManualformsMaster_action })(ManageArea));